import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type SortBy = 'sort-order' | 'name-asc' | 'name-desc' | 'updated-desc' | 'updated-asc';

interface Work4MeFiltersToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  sortBy: SortBy;
  onSortChange: (value: SortBy) => void;
}

export function Work4MeFiltersToolbar({
  search,
  onSearchChange,
  sortBy,
  onSortChange,
}: Work4MeFiltersToolbarProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="relative w-[240px] sm:w-[280px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by name..."
          className="h-9 pl-10"
        />
      </div>
      <Select value={sortBy} onValueChange={(v) => onSortChange(v as SortBy)}>
        <SelectTrigger className="w-[140px] sm:w-[170px] h-9">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="sort-order">Sort order</SelectItem>
          <SelectItem value="name-asc">Name (A-Z)</SelectItem>
          <SelectItem value="name-desc">Name (Z-A)</SelectItem>
          <SelectItem value="updated-desc">Updated (Newest)</SelectItem>
          <SelectItem value="updated-asc">Updated (Oldest)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
